import React from 'react'

import { BoxCenter } from '../../../generic/Box'
import Title from '../../../generic/Title'
import ReinfTypeFilter from './ReinfTypeFilter'
import ReinfTable from './ReinfTable'
import ReinfModal from './ReinfModal'

const ReinfList = props => {
  return (
    <BoxCenter>
      <Title>Arquivos XML</Title>
      <ReinfTypeFilter />
      <ReinfTable />
      <ReinfModal />
    </BoxCenter>
  )
}

export default ReinfList



// WEBPACK FOOTER //
// ./src/components/dashboard/products/4reinf/ReinfList.js